export const serviceGroupItemFrag = `
    id
    name
    type
    groupType
    description
    color
    active
    validFrom
    validTo
    settings
`;

export const serviceOfferGroupItemFrag = `
    id
    name
    type
    groupType
    description
    color
    active
    validFrom
    validTo
    offersCount
`;
